import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthenticationOidcService } from '../services/authentication-oidc-service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authenticationOidcService: AuthenticationOidcService,
    private oauthService: OAuthService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // If already logged in, allow access
    if (this.authenticationOidcService.isLoggedIn) {
      return true;
    }
    
    // Try to refresh token using refresh token if available
    if (this.oauthService.getRefreshToken()) {
      try {
        await this.authenticationOidcService.refreshToken();
        console.log('✅ Token refresh successful');
        if (this.authenticationOidcService.isLoggedIn) {
          return true;
        }
      } catch (error) {
        console.warn('⚠️ Token refresh failed, trying silent refresh:', error);
      }
    }
    
    // Fallback to silent refresh if refresh token method fails or is not available
    try {
      await this.authenticationOidcService.silentRefresh();
      console.log('✅ Silent refresh successful');
      if (this.authenticationOidcService.isLoggedIn) {
        return true;
      }
    } catch (error) {
      console.warn('⚠️ Silent refresh failed:', error);
    }

    // If all refresh attempts failed, redirect to unauthorized
    console.log('🚫 All token refresh attempts failed. Redirecting to /unauthorized');
    return this.router.createUrlTree(['/unauthorized']);
  }
}